import { useState } from "react";
import { Input } from "./ui/input";
import { formatMoney } from "../lib/format";
import { matchingAccounts } from "../lib/dues";

// A person's name for the dues, offering the people already on the list so that
// Rahul's second game lands on Rahul's account instead of opening another.
export default function DueNameField({ accounts, value, onChange, testId, autoFocus }) {
  const [focused, setFocused] = useState(false);
  const matches = focused ? matchingAccounts(accounts, value) : [];

  return (
    <div className="relative">
      <Input
        data-testid={testId}
        autoFocus={autoFocus}
        placeholder="Whose name?"
        maxLength={40}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className="h-11 bg-[#09090b] border-zinc-700 text-zinc-100 placeholder:text-zinc-500"
      />
      {matches.length > 0 && (
        <div className="absolute z-10 mt-1 w-full rounded-lg border border-zinc-700 bg-[#18181b] py-1 shadow-lg">
          {matches.map((a) => (
            <button
              key={a.id}
              type="button"
              data-testid={`${testId}-match`}
              // Before the field's blur, or the list closes under the tap
              onMouseDown={(e) => { e.preventDefault(); onChange(a.name); setFocused(false); }}
              className="flex w-full items-center justify-between gap-3 px-3 py-2 text-left text-sm text-zinc-200 hover:bg-zinc-800"
            >
              <span className="truncate">{a.name}</span>
              {a.balance > 0 && <span className="shrink-0 text-xs text-amber-400">owes ₹{formatMoney(a.balance)}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
